import type { DashboardFilters } from '@oxxean/types';
import { requestBlob } from '../http';
import { todayInChile } from '../format';
import { filtersToParams } from './params';

export const EXPORT_FORMATS = ['xlsx', 'csv', 'pdf'] as const;
export type ExportFormat = (typeof EXPORT_FORMATS)[number];

export const EXPORT_FORMAT_LABEL: Record<ExportFormat, string> = {
  xlsx: 'Excel (.xlsx)',
  csv: 'CSV (.csv)',
  pdf: 'PDF (.pdf)',
};

const EXTENSION: Record<ExportFormat, string> = { xlsx: 'xlsx', csv: 'csv', pdf: 'pdf' };

/**
 * Descarga una exportación.
 *
 * Los mismos filtros globales que alimentan la pantalla acompañan la solicitud, y
 * el backend adjunta los metadatos de procedencia al archivo (§26): un número no
 * debe circular fuera de la plataforma sin su contexto.
 */
export async function downloadExport(
  moduleKey: string,
  format: ExportFormat,
  filters: DashboardFilters,
): Promise<void> {
  const { blob, filename } = await requestBlob(`/exports/${moduleKey}`, {
    ...filtersToParams(filters),
    format,
  });

  // El día en Chile, no en UTC: por la tarde el sello UTC ya es del día siguiente.
  const stamp = todayInChile();
  const fallback = `oxxean-${moduleKey}-${stamp}.${EXTENSION[format]}`;
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename ?? fallback;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
